import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=9d5e2cd2&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiFormField: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Form/Field.vue').default,UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default,UiForm: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Form/index.vue').default})
